module.exports = __webpack_public_path__ + "static/media/015-Aktivierung_ID_42.0599b933.mp3";